export const T = {
  navy: '#0A2540',
  navyDk: '#051221',
  teal: '#00D4FF',
  white: '#FFFFFF',
  text: '#1F2937',
  textSec: '#6B7280',
  textTer: '#9CA3AF',
  success: '#10B981',
  warning: '#F59E0B',
  danger: '#EF4444',
  info: '#3B82F6',
  border: '#E5E7EB',
  borderLight: '#F3F4F6',
  ice: '#F9FAFB',
  shadow: '0 1px 3px rgba(0,0,0,0.1)',
  shadowLg: '0 4px 6px rgba(0,0,0,0.1)',
  font: 'system-ui, -apple-system, sans-serif',
  mono: 'ui-monospace, monospace',
  bg: '#F8FAFC',
  primary: '#2563EB',
  secondary: '#64748B',
  borderDark: '#CBD5E1',
  overlay: 'rgba(0,0,0,0.5)',
  overlap: '#0B2347',
  purple: '#8B5CF6',
  shadowMd: '0 4px 6px -1px rgba(0,0,0,0.1)',
  containerPadding: '16px',
  maxWidth: '1060px',
  desktop: '@media (min-width: 1024px)',
  md: '@media (min-width: 768px)',
};

import React from 'react';
import NHCLogoDefault from './NHCLogo';

export const NHCAppHeader = ({ title = 'Header', onBack }: any) => (
  <div style={{ padding: '16px', background: T.navy, color: T.white, display: 'flex', alignItems: 'center' }}>
    {onBack && <span onClick={onBack} style={{ cursor: 'pointer', marginRight: 10 }}>← Back</span>}
    <strong>{title}</strong>
  </div>
);

export type Role = 'patient' | 'doctor' | 'admin';

export const NHCAuditTimeline = (_props: { title?: string; entries?: { text: string; time: string; color?: string }[] } = {}) =>
  <div style={{ padding: 10, background: '#eee' }}>Audit Timeline</div>;

export const NHCLogo = NHCLogoDefault;

export const NHCLogoSquare = ({ size = 40 }: any) => <NHCLogoDefault size={size} />;

// Honest verification block — renders the REAL verification state. A card is
// only "NeoVerified" when the backend says the profile is approved; anything
// else shows a pending state, never a fabricated tick.
export const NHCNeoVerifyBlock = ({ verified }: { nhcId?: string; entityName?: string; entityType?: string; verified?: boolean } = {}) =>
  verified ? (
    <div style={{ padding: 10, background: '#e0f2f1', color: '#00796b', fontWeight: 600 }}>NeoVerified ✓</div>
  ) : (
    <div style={{ padding: 10, background: '#FEF3C7', color: '#92400E', fontWeight: 600 }}>Verification pending</div>
  );

// Real scannable QR of the card id (nothing rendered without an id).
export const NHCQRNFCPanel = ({ nhcId, label }: { nhcId?: string; label?: string } = {}) => {
  const [dataUrl, setDataUrl] = React.useState<string | null>(null);
  React.useEffect(() => {
    let alive = true;
    if (!nhcId) { setDataUrl(null); return; }
    import('qrcode').then((QRCode) =>
      QRCode.toDataURL(nhcId, { margin: 1, width: 160 }).then((url: string) => { if (alive) setDataUrl(url); }),
    ).catch(() => { if (alive) setDataUrl(null); });
    return () => { alive = false; };
  }, [nhcId]);
  if (!nhcId) {
    return <div style={{ padding: 20, textAlign: 'center', background: '#F3F4F6', color: '#6B7280', fontSize: 12 }}>No card ID yet</div>;
  }
  return (
    <div style={{ padding: 12, textAlign: 'center', background: '#FFFFFF' }}>
      {dataUrl
        ? <img src={dataUrl} alt={`QR code for ${nhcId}`} style={{ width: 160, height: 160 }} />
        : <div style={{ width: 160, height: 160, margin: '0 auto', background: '#F3F4F6' }} />}
      <div style={{ fontSize: 10, color: '#6B7280', marginTop: 6 }}>{label || nhcId}</div>
    </div>
  );
};
